var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-dropdown-menu',[_c('van-dropdown-item',{attrs:{"options":_vm.option},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }